export default __webpack_public_path__ + "static/media/CoreUI-Icons-Free.8f9e0f7b.woff";